import { Component } from 'react';
import styles from './index.module.scss';
import cn from 'classnames';
import { PesMaxCapacityCell, PesRuntimeField, PesRuntimeHeadingCell, PesRuntimeLoadCell } from '@pes-ui/components-react';
import { MappedProduct } from '../../utils/mappers';
import { ComparatorRuntimeInfo } from '@pes-ui/utils/lib/types/comparator';

type Props = {
    products: string[];
    leftProduct: MappedProduct | object;
    rightProduct: MappedProduct | object;
    runtimeInfo: ComparatorRuntimeInfo;
    toggleState: boolean;
}

type State = {
    toggleSectionsState: boolean;
    runTimeInput: string;
}

class MobileRunTimeWidget extends Component <Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            toggleSectionsState: true,
            runTimeInput: '',
        };
    }

    static defaultProps = {
        leftProduct: {},
        rightProduct: {},
    };

    handleToggleClick = () => {
        this.setState({
            toggleSectionsState: !this.state.toggleSectionsState,
        })
    }

    handleInput = (event) => {
        this.setState({runTimeInput: event.detail});
    }

    defaultMaxValue = (items: string[]): number => {
        const {runtimeInfo} = this.props;
        const maxValues = items.reduce((maxValue, item) => {
            if (runtimeInfo?.items[item]?.maxPower) {
                maxValue.push(runtimeInfo.items[item].maxPower);
            }
            return maxValue;
        }, []);
        return Math.min(...maxValues);
    }

    defaultMinValue = (items: string[] ): number => {
        const {runtimeInfo} = this.props;
        const minValues = items.reduce((minValue, item) => {
            if (runtimeInfo?.items[item]?.startPoint) {
                minValue.push(runtimeInfo.items[item].startPoint)
            }
            if (runtimeInfo?.items[item]?.maxPower) {
                minValue.push(Math.ceil(runtimeInfo?.items[item]?.maxPower * 0.1))
            }
            return minValue;
        }, []);
        return Math.max(...minValues);
    }

    renderLoadCellProperty = (mappedProduct) => {
        const { runtimeInfo } = this.props;
        return runtimeInfo?.items[mappedProduct.productId] ?
            <div className={styles.categoryValue}>
                <PesRuntimeLoadCell 
                    labels={runtimeInfo.translations}
                    runtimeParams={runtimeInfo.items[mappedProduct.productId]}
                    value={this.state.runTimeInput}
                />
            </div>
            :
            <div className={styles.categoryValue}>
                <PesRuntimeLoadCell
                    default={true}
                />
            </div>
                
    }

    renderMaxCapacityCell = (mappedProduct) => {
        const { runtimeInfo } = this.props;
        return (
            runtimeInfo?.items[mappedProduct.productId] ?
            <div className={styles.categoryValue}>
                <PesMaxCapacityCell 
                    labels={runtimeInfo.translations}
                    runtimeParams={runtimeInfo.items[mappedProduct.productId]}
                    value={this.state.runTimeInput}
                />
            </div>
            : <div className={styles.categoryValue}>
                <PesMaxCapacityCell
                    default={true}
                />
            </div>
        );
    }

    render() {
        const { leftProduct, rightProduct, runtimeInfo, products, toggleState } = this.props;

        return (
            <div className={cn({
                [styles.isShown]: toggleState,
            })}>
                <div
                    className={cn({
                        [styles.categoryContent]:true,
                        [styles.isShown]: !this.state.toggleSectionsState
                    })}
                >
                    <div className={styles.categoryParameter} role="rowheader">
                        <PesRuntimeField 
                            onPesRuntimeDidSubmit = {this.handleInput}
                            labels={runtimeInfo.translations}
                            max={this.defaultMaxValue(products)}
                            min={this.defaultMinValue(products)}
                            isError={Number(this.state.runTimeInput) > this.defaultMaxValue(products)}
                        />
                    </div>
                    <div className={styles.categoryResults}>
                        {this.renderLoadCellProperty(leftProduct)}
                        {this.renderLoadCellProperty(rightProduct)}
                    </div>
                </div>
                <div
                    className={cn({
                        [styles.categoryContent]:true,
                        [styles.isShown]: !this.state.toggleSectionsState
                    })}
                >
                    <div className={styles.categoryParameter} role="rowheader">
                        <PesRuntimeHeadingCell tooltipText={runtimeInfo?.translations?.indicatesCapacity}>
                            {runtimeInfo.translations.maxCapacityUsed}
                        </PesRuntimeHeadingCell>
                    </div>
                    <div className={styles.categoryResults}>
                        {this.renderMaxCapacityCell(leftProduct)}
                        {this.renderMaxCapacityCell(rightProduct)}
                    </div>
                </div>
            </div>
        )
    }
}

export default MobileRunTimeWidget;